export default "__VITE_ASSET__CEzY5tXW__"